import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Bolt0_res$Bolt0 from "bolt0/./bolt0_res.bs.js";
import * as Bolt0_list$Bolt0 from "bolt0/./bolt0_list.bs.js";

function Make(Record_param) {
  var Private = {
    Record_param: Record_param
  };

  var project_column = function project_column(table, label, arg_type) {
    var cell = Curry._2(Record_param.flag1, label, Curry._1(Record_param.Flag.required, arg_type));

    if (typeof table === "number" || table[0] !== 848054398) {
      return (
        /* `Error */
        [106380200,
        /* Invalid */
        144245463]
      );
    } else {
      return Bolt0_res$Bolt0.all(Bolt0_list$Bolt0.map(function (record) {
        if (typeof record === "number" || record[0] !== 847309489) {
          return (
            /* `Error */
            [106380200,
            /* Invalid */
            144245463]
          );
        } else {
          var arg = function arg(param) {
            return (
              /* Invalid */
              144245463
            );
          };

          return function (param) {
            return Bolt0_res$Bolt0.map_error(param, arg);
          }(Curry._2(Record_param.parse, record[1], cell));
        }
      }, table[1]));
    }
  };

  return {
    Private: Private,
    project_column: project_column
  };
}

export { Make };
/* No side effect */